import { render, staticRenderFns } from "./full.vue?vue&type=template&id=63fdb9be&scoped=true"
import script from "./full.vue?vue&type=script&setup=true&lang=js"
export * from "./full.vue?vue&type=script&setup=true&lang=js"
import style0 from "./full.vue?vue&type=style&index=0&id=63fdb9be&prod&lang=less"
import style1 from "./full.vue?vue&type=style&index=1&id=63fdb9be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fdb9be",
  null
  
)

export default component.exports